import { Outlet, useLocation } from "react-router-dom";

import Sidebar from "components/Sidebar";
import { useNewDashboardDesign } from "hooks/useNewDashboardDesign";
import { path as HomePath } from "v2/pages/home/HomeRoute";
import { cx } from "utils";


export default function SidebarLayout() {
  const { newDashboardDesignSetting } = useNewDashboardDesign();
  const location = useLocation();

  // sidebar should always use the new design if user opted in for any of the redesigned pages
  const darkModeForSidebar = (newDashboardDesignSetting === "yes");
  // main section should only use the new design if we're on those pages (or on their sub-pages)
  const darkModeForMain = (newDashboardDesignSetting === "yes") && (location.pathname.startsWith(HomePath));

  return (
    <div className="size-full flex flex-col md:flex-row">
      <div className={ cx("shrink-0", darkModeForSidebar && "dark") }>
        <Sidebar />
      </div>
      {/* need to override the default minimum width, otherwise some features like text truncation won't work */}
      <div className="flex flex-col size-full min-w-0">
        <div className={ cx("flex-1 basis-0 overflow-y-auto", darkModeForMain && "dark") }>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
